import { getLocalStorageSideloadApps } from './getLocalStorageSideloadApps';
export var getSideloadedApps = function (puid) {
    return getLocalStorageSideloadApps(puid) || [];
};
//# sourceMappingURL=getSideloadedApps.js.map